import React from 'react';
import slide1 from './slide1.svg'
import slide2 from './slide2.svg'
import slide3 from './slide3.svg'
import CustomCarousel from '../common/CustomCarousel/CustomCarousel';

const slides = [
  {
    id: 0,
    img: slide1,
  },
  {
    id: 1,
    img: slide2,
  },
  {
    id: 2,
    img: slide3,
  },
];

export default function WelcomeSlider(props) {
  return <CustomCarousel slides={slides} {...props} translationNamespace={'welcomeSlider'} />
}
